/**
 * Nyafaz EP presentation / demo kiosk — isolated from live salon hub flows.
 * Update credentials and guest profile here (or via REACT_APP_PRESENTATION_* env vars).
 */

export const PRESENTATION_FRANCHISE_USERNAME =
  process.env.REACT_APP_PRESENTATION_FRANCHISE_USERNAME || 'nt02';

export const PRESENTATION_FRANCHISE_CODE =
  process.env.REACT_APP_PRESENTATION_FRANCHISE_CODE || 'nt02';

export const PRESENTATION_FRANCHISE_PASSWORD =
  process.env.REACT_APP_PRESENTATION_FRANCHISE_PASSWORD || 'abcd1234';

export const PRESENTATION_CUSTOMER_NAME =
  process.env.REACT_APP_PRESENTATION_CUSTOMER_NAME || 'Guest';

export const PRESENTATION_CUSTOMER_MOBILE =
  process.env.REACT_APP_PRESENTATION_CUSTOMER_MOBILE || '8122147959';

/** Demo guest gender for franchise price lists (skin / treatment / product APIs). */
export const PRESENTATION_CUSTOMER_GENDER =
  process.env.REACT_APP_PRESENTATION_CUSTOMER_GENDER || 'female';

/** Reels: service type id (see naturals/video ServiceSelect SERVICES). */
export const PRESENTATION_REELS_SERVICE_TYPE_ID =
  process.env.REACT_APP_PRESENTATION_REELS_SERVICE_TYPE || 'haircut';

/** Desk “started service” label for reel-eligible check-in. */
export const PRESENTATION_REELS_STARTED_SERVICE_NAME =
  process.env.REACT_APP_PRESENTATION_REELS_SERVICE_NAME || 'Haircut';

/** Naturals customer engagement UI. Tile is hidden when unset. Opens in a new tab. */
export const PRESENTATION_CUSTOMER_ENGAGE_URL = (
  process.env.REACT_APP_NATURALS_ENGAGEMENT_APP_URL ||
  process.env.REACT_APP_DEMO_ENGAGEMENT_APP_URL ||
  '/nyafaz-ep/engagement'
).trim();

/** Fixed presentation hub backdrop (not franchise kiosk landing). */
export const PRESENTATION_HUB_BACKGROUND_PATH =
  '/engagement/Lavender Luxe Spa with Golden Light.png';

export function presentationHubBackgroundStyle() {
  const url = encodeURI(
    `${process.env.PUBLIC_URL || ''}${PRESENTATION_HUB_BACKGROUND_PATH}`,
  );
  return { '--naturals-hub-bg': `url("${url}")` };
}

export const PRESENTATION_HUB_PATH = '/nyafaz-ep/presentation';
export const PRESENTATION_LOGIN_PATH = '/nyafaz-ep/presentation/login';

/** Nyafaz EP presentation beauty studios — same routes as live salon hub. */
export const PRESENTATION_NATURALS_MAKEUP_CAPTURE = '/nyafaz-ep/makeup/capture';
export const PRESENTATION_NATURALS_HAIR_COLOR_CAPTURE = '/nyafaz-ep/hair-coloring/capture';
export const PRESENTATION_NATURALS_HAIR_STYLE_CAPTURE = '/nyafaz-ep/hair-styling/capture';
export const PRESENTATION_NATURALS_HAIR_ANALYSIS_HOME = '/nyafaz-ep/hair';
